var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoicedetailsblue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.376 27H2.62489C1.17652 27 0 25.7879 0 24.3005V2.70037C0 1.41538 1.17652 0 2.62489 0H14.9819L21 6.19114V24.3005C21 25.7879 19.8235 27 18.376 27ZM18.376 8.10019H13.1245V2.70037H2.62489V24.3005H18.3769L18.376 8.10019ZM13.1245 14.8497H5.24977V12.1503H13.1245V14.8497ZM15.7502 20.2505H5.24977V17.5501H15.7502V20.2505Z",
    fill: "#3DA3B8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicedetailsblue);
export default __webpack_public_path__ + "static/media/invoicedetailsblue.ddaf40580c7b70f719ba8cb4e08c6957.svg";
export { ForwardRef as ReactComponent };